import './index.sass';
import './challenge-header/index.sass';

export default ($root) => {
    const $tab = $root.find('.js-change-challenge');

    $tab.on('click', function (e) {
        e.preventDefault();

        const $this = $(this);
        const id = $this.attr('data-tab');
        $tab.removeClass('switches__controls-link--active');
        $this.addClass('switches__controls-link--active');

        if(id == 'lessons') {
            $root.find('.switches').removeClass('switches--challenge');
        } else {
            $root.find('.switches').addClass('switches--challenge');
        }

        $root.find('[data-list]').hide();
        $root.find(`[data-list="${id}"]`).show();
    });

    $root.find('.js-lesson-enter').on('click', function(e, data) {
        // console.log(data)
        // if (data.url) window.location.href = data.url
    });
}
